import { useQuery } from '@tanstack/react-query'
import { ETICHETE_STARE, type StareContainer } from '@b4l/shared'
import { api } from '../../../lib/api'
import { Card } from '../../ui/Card'

/** Cine a mutat statusul, când și de ce. Read-only, ca și în fundația v2 care l-a scris. */

interface Intrare {
  id: number
  statusVechi: string | null
  statusNou: string
  motiv: string | null
  schimbatLa: string
  schimbatDe: { id: number; name: string | null; email: string } | null
}

function clipa(iso: string): string {
  const d = new Date(iso)
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
}

export function FilaIstoric({ campanieId }: { campanieId: number }) {
  const q = useQuery<{ istoric: Intrare[] }>({
    queryKey: ['campanie', campanieId, 'istoric'],
    queryFn: async () => (await api.get(`/campanii/${campanieId}/istoric`)).data,
  })
  const istoric = q.data?.istoric ?? []

  return (
    <Card title="Istoricul stării">
      {istoric.length === 0 ? (
        <p className="text-sm text-b4l-text-muted">
          Starea nu a fost schimbată de când există istoricul.
        </p>
      ) : (
        <ul className="divide-y divide-b4l-border text-sm">
          {istoric.map((i) => (
            <li key={i.id} className="flex items-center gap-3 py-2">
              <span className="w-36 text-xs text-b4l-text-muted">{clipa(i.schimbatLa)}</span>
              <span>
                {i.statusVechi ? eticheta(i.statusVechi) : '—'} →{' '}
                <strong>{eticheta(i.statusNou)}</strong>
              </span>
              {i.motiv && <span className="text-b4l-text-muted">· {i.motiv}</span>}
              <span className="ml-auto text-xs text-b4l-text-muted">
                {i.schimbatDe?.name ?? i.schimbatDe?.email ?? '—'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  )
}

/** Eticheta starii; o cheie necunoscuta (veche) ramane cum e. */
function eticheta(s: string): string {
  return ETICHETE_STARE[s as StareContainer] ?? s
}
